import theme from "@/styles/theme";
import { StyledIOSSwitch } from "./styles";

interface IOSSwitchProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  backgroundColor?: string;
}
export const Toggle: React.FC<IOSSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  backgroundColor = theme.colors.palete.brownLight
}) => {
  return (
    <StyledIOSSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      backgroundColor={backgroundColor}
    />
  );
};
